import { TokenSelectionDrawer } from '@ui/components/TokenSelectionDrawer';
import type { LiquidityStrategyDepositToken } from '@ui/utils/strategy';
import {
  LiquidityStrategyTokenDict,
  useDepositTokenBalances,
} from '@ui/utils/strategy';

type StrategyTokenSelectionDrawerProps = {
  onClose: () => void;
  isOpen: boolean;
  value: LiquidityStrategyDepositToken;
  preferred?: LiquidityStrategyDepositToken;
  onChange: (token: LiquidityStrategyDepositToken) => void;
};

export const StrategyTokenSelectionDrawer = ({
  onClose,
  isOpen,
  value,
  onChange,
  preferred,
}: StrategyTokenSelectionDrawerProps) => {
  const tokenList: LiquidityStrategyDepositToken[] = [
    'cro',
    'wcro',
    'lcro',
    'ferroLP',
  ];
  const tokenBalanceDict = useDepositTokenBalances();
  const tokenDict = LiquidityStrategyTokenDict;

  return (
    <TokenSelectionDrawer
      onClose={onClose}
      isOpen={isOpen}
      value={value}
      onChange={(token) => onChange(token)}
      tokenList={tokenList}
      tokenBalanceDict={tokenBalanceDict}
      tokenDict={tokenDict}
      preferred={preferred}
    />
  );
};
